import { Component, Input } from '@angular/core';
import { FieldComponent } from 'tuain-ng-forms-lib';

@Component({
  selector: 'app-label',
  templateUrl: './app-label.component.html',
})
export class AppLabelComponent extends FieldComponent {
  @Input() labelType: any;
}
